import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './HardwareDownload.cssmodule.less';
import { clickButton } from '../../actions/Modal';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';
import classNames from 'classnames';

class HardwareDownload extends BaseComponent {
    constructor(props) {
        super(props);
        this.setConfirmTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    setConfirmTheme(theme) {
        const themeStyle = this.getTheme(theme, 'HARDWARE_DOWNLOAD');
        this.Style = themeStyle || Style;
    }

    render() {
        // console.log(this.Style);
        return (
            <div className={this.Style.HardwareDownload}>
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    {this.Utils.getLang('Msgs.not_install_title')}
                </Title>
                <div className={this.Style.contentView}>
                    <div className={this.Style.content}>
                        <div className="textArea">
                            <div>
                                <p>
                                    {this.Utils.getLang(
                                        'Msgs.hw_download_text1'
                                    )}
                                </p>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: this.Utils.getLang(
                                            'Msgs.hw_download_text2'
                                        ),
                                    }}
                                />
                            </div>
                            <div className={this.Style.description}>
                                <p>
                                    {this.Utils.getLang(
                                        'Msgs.hw_download_text3'
                                    )}
                                </p>
                                <p>
                                    {this.Utils.getLang(
                                        'Msgs.hw_download_text4'
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <Button
                            className={classNames(
                                this.Style.button,
                                this.Style.cancelButton
                            )}
                            text={this.Utils.getLang('Buttons.cancel')}
                            onClick={() => this.handleButtonClick('cancel')}
                        />
                        <Button
                            className={this.Style.button}
                            onClick={() => this.handleButtonClick('ok')}
                        >
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: this.Utils.getLang(
                                        'Msgs.hw_download_btn'
                                    ),
                                }}
                            />
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

HardwareDownload.displayName = 'HardwareDownload';
HardwareDownload.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(HardwareDownload);



// WEBPACK FOOTER //
// ./components/ModalSet/HardwareDownload.js